var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReplyFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 26 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.451 8.09 5.977 6.01 1.1-1.094L4.41 8.865h13.793a5.633 5.633 0 0 1 5.626 5.625 5.633 5.633 0 0 1-5.626 5.626H1.378v1.55h16.824c3.956 0 7.176-3.22 7.176-7.176s-3.22-7.176-7.176-7.176H4.387L8.54 3.087 7.435 2 1.45 8.09Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReplyFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ReplyFilled.74ffb4582161101510a7918b7980beb5.svg";